const doctorsSwiper = new Swiper('.doctors-swiper', {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    grabCursor: true,
    loopAdditionalSlides: 4, // ← Add this, clones extra slides
    centeredSlides: false,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
        waitForTransition: false, // ← Add this
    },
    speed: 800,
    pagination: {
        el: '.doctors-swiper .swiper-pagination',
        clickable: true,
    },
    navigation: {
        prevEl: '#doctorsPrev',
        nextEl: '#doctorsNext',
    },
    breakpoints: {
        480: { slidesPerView: 1 },
        640: { slidesPerView: 2 },
        992: { slidesPerView: 3 },
        1100: { slidesPerView: 4 },
    },
});